// extracted by mini-css-extract-plugin
export default {"CardMap":"card-map_CardMap__scPXZ","CardMap__icon":"card-map_CardMap__icon__AcN9r"};